module.exports = __webpack_public_path__ + "14four/static/media/img_1.8b4313e8.png";